import {Utils} from "./Utils";

export interface FileLoaderConfig {
    input: HTMLInputElement;
    dropzone: HTMLElement;
    hint?: HTMLElement;
    bin?: HTMLElement;
    storage?: HTMLInputElement;
}

export class FileLoader {
    private readonly elements: {
        input: HTMLInputElement;
        dropzone: HTMLElement;
        hint?: HTMLElement;
        bin?: HTMLElement;
        storage?: HTMLInputElement;
    };

    constructor({input, dropzone, hint, bin, storage}: FileLoaderConfig) {
        this.elements = {input, dropzone, hint, bin, storage};
        this.bind();
    }

    public message(): string {
        return (Utils.getLang() === `ru_ru`)
            ? `Загружен файл: `
            : `File uploaded: `;
    }

    protected updateHint(file: File): void {
        if (!this.elements.hint) return;
        let msg = this.message();
        msg = (file.name.length > 25)
            ? msg.concat(file.name.substring(0, 25))
            : msg.concat(file.name);
        this.elements.hint.textContent = msg;
    }

    public remove(evt: Event): void {
        evt.preventDefault();
        const {bin, storage} = this.elements;

        if (bin || storage) {
            const preview = bin.parentElement;
            preview.style.display = `none`;
            storage.value = ``;
        }
    }

    protected bind(): void {
        const {input, dropzone, bin} = this.elements;
        input.addEventListener('change', evt => {
            if (input.files.length) this.updateHint(input.files[0]);
        });

        dropzone.addEventListener('dragover', (evt) => {
            evt.preventDefault();
            dropzone.classList.add("is-over");
        });

        ['dragleave', 'dragend'].forEach((type) => {
            dropzone.addEventListener(type, (evt) => {
                dropzone.classList.remove("is-over");
            });
        });

        dropzone.addEventListener('drop', (evt) => {
            evt.preventDefault();

            if (evt.dataTransfer.files.length) {
                input.files = evt.dataTransfer.files;
                this.updateHint(evt.dataTransfer.files[0]);
            }
            dropzone.classList.remove("is-over");
        });

        if (bin) bin.addEventListener(`click`, (evt) => this.remove(evt));
    }
}